export default function getStyles(props, styles = {}) {
  return {
    wrapperDesktop: {
      display: 'flex',
      justifyContent: 'center'
    },
    imageOuter: {
      position: 'relative',
      marginBottom: 'small',
      width: '100%',
      height: '100%'
    },
    imageWrapper: {
      maxWidth: '100%',
      width: '100%'
    },
    imageDesktop: {
      maxHeight: '100%',
      maxWidth: '100%',
      flexShrink: 0
    },
    thumbset: {
      paddingTop: '0',
      display: 'flex',
      alignItems: 'center'
    },
    thumbsetThumbs: {
      display: 'flex',
      padding: '0',
      margin: '0 -2px'
    },
    thumbArrowUp: {
      paddingLeft: 'xsmall',
      fontColor: 'section',
      cursor: 'pointer',
      zIndex: '2',
      height: '50px',
      display: 'flex',
      alignItems: 'center',
      padding: '0 !important'
    },
    thumbArrowRight: {
      paddingLeft: 'xsmall',
      fontColor: 'section',
      cursor: 'pointer',
      zIndex: '2',
      height: '50px',
      display: 'flex',
      alignItems: 'center'
    },
    thumbArrowDown: {
      paddingLeft: 'xsmall',
      fontColor: 'section',
      cursor: 'pointer',
      zIndex: '2',
      height: '50px',
      display: 'flex',
      alignItems: 'center',
      padding: '0 !important'
    },
    thumbArrowLeft: {
      paddingRight: 'xsmall',
      fontColor: 'section',
      cursor: 'pointer',
      zIndex: '2',
      height: '50px',
      display: 'flex',
      alignItems: 'center'
    },
    ...styles
  };
}
